import i18n from '@/helpers/dataConverter/i18n';
import moment from 'moment';
import 'moment-timezone';
window.moment = moment;
let afterSetExtremesCallback;

const afterSetExtremes = (e) => {
  if (afterSetExtremesCallback) {
    afterSetExtremesCallback(e);
    return;
  }
  console.warn('afterSetExtremes is not setted for chart');
}

const tooltipFormatter = function () {
  const points = this.points;
  let tooltipArray = [
    i18n.d(new Date(this.x), 'long'),
  ];
  points.forEach(function (point) {
    const template = `<span style="color:${point.series.color}">${point.series.name}</span>: <b>${point.y}</b><br/>`;
    tooltipArray.push(template);
  });
  return tooltipArray;
}

const config = {
  'constructor-type': 'stockChart',
  options: {
    time: {
      moment,
      timezone: Intl.DateTimeFormat().resolvedOptions().timeZone
    },

    chart: {
      backgroundColor: 'rgba(0,0,0,0)',
      zoomType: 'x',
    },

    rangeSelector: {
      enabled: false,
    },

    scrollbar: {
      enabled: false,
      liveRedraw: false,
    },

    navigator: {
      enabled: false,
      adaptToUpdatedData: false,
      xAxis: {
        labels: {
          format: '{value:%b %d, %H:%M}',
          align: 'center',
          y: 12,
        },
      },
      series: [],
    },

    title: {
      text: null,
    },

    credits: false,

    legend: {
      enabled: false,
    },

    plotOptions: {
      spline: {
        marker: {
          enabled: false,
        },
      },
      series: {
        lineWidth: 1,
        color: '#555FB9',
        dataGrouping: {
          enabled: true,
        },
      },
    },

    xAxis: {
      ordinal: false,
      tickWidth: 1,
      breaks: [],
      min: null,
      max: null,
      events: {},
    },

    yAxis: [],

    tooltip: {
      split: true,
      valueDecimals: 2,
      formatter: null
    },

    series: [],
  },
}


const getConfig = (params) => {
  if (params) {
    afterSetExtremesCallback = params.afterSetExtremes;
  }

  const copy = JSON.parse(JSON.stringify(config));
  copy.options.xAxis.events.afterSetExtremes = afterSetExtremes;
  copy.options.tooltip.formatter = tooltipFormatter;
  return copy;
}

export { getConfig };